<template>
  <align class="saved-options-dropdown" small-gap>
    <dropdown
      v-show="options.length > 0"
      :align="align"
      :active="menuOpen"
      @close="menuOpen = false"
    >
      <pill sortable :empty="!activeOption" @click.native="menuOpen = !menuOpen">
        {{ activeOption ? activeOption.name : label }}
      </pill>

      <template #menu>
        <div class="dropdown-menu">
          <button
            v-for="(option, i) in options"
            :key="i"
            :class="{ active: option.active }"
            @click="select(option)"
          >
            <icon
              v-show="activeOption"
              class="success"
              :class="{ hide: !option.active }"
              name="check_circle"
            />

            <div class="option-text">
              <strong>{{ option.name }}</strong>
              <small>{{ option.description }}</small>
            </div>

            <template v-if="!hideSave">
              <icon-button icon="drive_file_rename_outline" @click.stop.prevent="edit(option)" />
              <icon-button icon="delete_outline" @click.stop.prevent="deleteOption(option)" />
            </template>
          </button>
        </div>
      </template>
    </dropdown>

    <icon-button
      v-if="allowDeselect && activeOption"
      icon="close"
      @click="select(null)"
    />

    <icon-button
      v-if="!hideSave"
      icon="save"
      :disabled="saveDisabled || !!activeOption"
      @click="$emit('save')"
    />
  </align>
</template>

<script>
export default {
  props: {
    label: String,
    options: Array,
    saveDisabled: Boolean,
    hideSave: Boolean,
    allowDeselect: Boolean,
    align: {
      type: String,
      default: 'right',
    },
  },

  data() {
    return {
      menuOpen: false,
    };
  },

  computed: {
    activeOption() {
      return this.options.find((option) => option.active);
    },
  },

  methods: {
    edit(option) {
      this.$emit('edit', option);
      this.menuOpen = false;
    },

    select(option) {
      this.$emit('select', option);
      this.menuOpen = false;
    },

    deleteOption(option) {
      if (this.options.length === 1) {
        this.menuOpen = false;
      }

      this.$emit('delete', option);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
  max-width: 250px;

  @media($medium-up) {
    max-width: 450px;
  }

  > button {
    @include ellipsis;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    color: inherit;
    text-align: left;
    gap: $gp * .5;
    padding: $gp * .5;
    width: 100%;
    cursor: pointer;

    .option-text {
      display: flex;
      flex-direction: column;
      gap: $gp * .25;
      margin-right: $gp * .5;
      flex: 1;
      @include ellipsis;

      > * {
        @include ellipsis;
      }
    }

    .icon.hide {
      opacity: 0;
    }

    &:hover {
      background-color: var(--theme-highlight);
    }

    &.active {
      background-color: var(--theme-active);
    }
  }
}
</style>
